import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHUkBusinessSolutionBody from "./Components/BodyUKBusinessSolution";

class CHUkBusinessSolution extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHUkBusinessSolutionBody />
        <Footer />
      </>
    );
  }
}

export default CHUkBusinessSolution;
